var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Рассылка промокодов")]),_vm._v(" "),_c('p',[_vm._v("Команда "+_vm._s(_vm.host)+" благодарит Вас за оказанное доверие. В знак признательности, мы будем регулярно рассылать промокоды постоянным игрокам. Приятной игры!")])])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// c:/Jenkins/workspace/play-at-home-test-frontend-deploy-sites/src/onlinecasino/OnlineCasino.Web.Public/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!c:/Jenkins/workspace/play-at-home-test-frontend-deploy-sites/src/onlinecasino/OnlineCasino.Web.Public/node_modules/vue-loader/lib??vue-loader-options!./skins/bulmasite/components/pages/sitepages/bonus-rules/bonus-rules-mailing/ru.vue?vue&type=template&id=7b6fcbef
// module id = g1NJ
// module chunks = 0